import React, { useState } from 'react'
import { marciDeMasini } from "../Add post/listcars";
import { listaAnFabricatie } from "../Add post/anFabricatie";
import { comfortOptions, audioOptions, sigurantaOptions, asistentaOptions ,pretCuTVAOption } from "../Add post/optiuni";
export const EditModal = ({
  comanda,
  setComanda,
  titlu, 
  setTitlu,
  setsku,
um,
setum,
 sku,
 material,
 setmaterial,
greutate,
setgreutate,
dimensiune,
setdimensiune,
  selectedImages,
  setSelectedImages,
  selectedMainImg,
  setSelectedMainImg,

  pret,
  setPret,

  handleMainImageChange,
  main,
  handleImagesChange,
  images,
  handleUpdate,
  theme,
  deleteSelectedImage,
  handleImageChange,
 
  pretCuTVA,
  setPretCuTVA,
  showModal , setShowModal,
  discount,
  setDiscount,




deleteSelectedMainImage
}) => {


 

 // Funcție de manipulare a ștergerii imaginii principale
 const handleDeleteMainImage = (imageName) => {
  deleteSelectedMainImage(imageName);
};






  return (
    <>
    

    <div className="modal fade modal-xl  " id="editModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  >
      <div className="modal-dialog modal-fullscreen  "  >
        <div className={`modal-content  ${theme === "dark" ? "dark-theme" : ""}`}>
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">Editare produs</h5>
          </div>
          <div className="modal-body" >
          { showModal && (
      <div className='modalLoading'>
        <div className="spinner-border  text-light" >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
        )}
            <div className="row g-3">
            <div className="row g-3">
            <div className="col-sm-12">
                  <div className="form-check form-check-inline ">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={comanda}
                      id="comanda"
                      onChange={(e) => setComanda(e.target.checked)}
                    />
                  <label className="form-check-label" htmlFor="comanda">
                  Pe stoc
                  </label>
                  </div>
                </div>

                 <div className="col-sm-12 mb-3">
                  <label htmlFor="titlu" className="form-label">
                    Titlu *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="titlu"
                    value={titlu}
                    
                    placeholder="Titlu produs.."
                  onChange={(e) => setTitlu(e.target.value)}
                />
              </div>
                </div>


              <div className="col-sm-3">
                  <label htmlFor="sku" className="form-label" >
                    Cod produs
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sku"
                    value={sku}
                  onChange={(e) => setsku(e.target.value)}
                />
                 
              </div>
              <div className="col-sm-2">
                  <label htmlFor="um" className="form-label">
  Unitate masura *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="um"
                    value={um}
               placeholder="buc, bax, set de 5.."
               onChange={(e) => setum(e.target.value)}
                  
                    required
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="material" className="form-label">
                   Material
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="material"
                    value={material}
                    onChange={(e)=>setmaterial(e.target.value)}
                  placeholder="otel, aluminiu"
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="greutate" className="form-label">
                   Greutate (kg)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="greutate"
                    value={greutate}
                    onChange={(e)=>setgreutate(e.target.value)}
                  placeholder="0.20 kg.."
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="dimensiune" className="form-label">
                   Dimensiuni (cm)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="dimensiune"
                    value={dimensiune}
                    onChange={(e)=>setdimensiune(e.target.value)}
                  placeholder="L x l x H"
                  />
                </div>

        
              {/* Imagini */}


              <div className="col-sm-4 col-xl-4 col-md-4">
                <p>Imagine Principala</p>
                <div className="text-center">
                {main && Object.keys(main).length > 0 && (
        <div className="text-center">
          <img
            src={Object.values(main)[0]}
            loading="lazy"
            alt={titlu}
            style={{
              width: '80px',
              height: '80px',
              objectFit: 'cover',
              marginRight: '5px',
              display: 'inline-block'
            }}
          />
          {/* <i
            className="fa-solid fa-trash text-center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const imageName = Object.keys(main)[0];
              handleDeleteMainImage(imageName);
            }}
          ></i> */}
        </div>
      )}

                </div>
              </div>
              <div className="col-sm-8 col-xl-8 col-md-8 text-left  text-md-left">
                <p>Restul imaginilor</p>
                <div className="row mb-4">
                  {images &&
                    Object.keys(images).map((key) => (
                      <div className='col-sm-2 text-center mx-1 mb-2' key={key}>
                        <img
                          src={images[key]}
                          alt={titlu}
                          loading='lazy'
                          className='text-center mb-2 '
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            marginRight: "5px",
                          }}
                        />
                        <i className="fa-solid fa-trash text-center" style={{ cursor: "pointer" }} onClick={() => deleteSelectedImage(key)}></i>
                      </div>
                    ))}
                </div>
              </div>
              <div className="col-sm-4">
                <label htmlFor="mainImage" className="form-label">
                  Schimbă imagine principală
                </label>
                <input
                  type="file"
                  className="form-control mb-2 input-text"
                  id="mainImage"
                  onChange={handleMainImageChange}
                />
              </div>



              <div className="col-sm-4 col-xl-4 col-md-6">
                <label htmlFor="images" className="form-label">
                  Schimbă toate imaginile - maxim 25
                </label>
                <input
                  type="file"
                  className="form-control mb-2"
                  id="images"
                  multiple
                  onChange={handleImagesChange}
                />
              </div>

            </div>
  <div className="row gy-3 ">
                <div className="col-sm-2">
                  <label htmlFor="pret" className="form-label">Preț *</label>
                  <input
                    type="number"
                    className="form-control"
                    id="pret"
                    value={pret}
                    onChange={(e)=>setPret(e.target.value)}
                    placeholder="fara TVA"
                    required
                  ></input>
                </div>
                <div className="col-sm-2">
                  <label htmlFor="discount" className="form-label">Preț redus*</label>
                  <input
                    type="number"
                    className="form-control"
                    id="discount"
                    value={discount}
                    onChange={(e)=>setDiscount(e.target.value)}
                   placeholder="fara TVA"
                   required
                  ></input>
                </div>
               
              </div>


            <div className="modal-footer mt-3">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Închide
              </button>
              <button className="btn btn-primary" onClick={handleUpdate}>
                Actualizare
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
    </>
  )
}
